import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { getServerSideProps as getHomeServerSideProps } from 'pages';
import { useEffect } from 'react';

import HomePage from 'components/pages/Home';

import useDialog from 'hooks/useDialog';

import LINKS from 'constants/links';

const WishlistDialog = dynamic(
  () => import('components/Wishlist/WishlistDialog'),
  { ssr: false }
);

const TIME_TO_OPEN_WISHLIST_DIALOG_IN_MILLISECONDS = 300;

const WishlistPage = ({
  cardsAds,
  cookieIsUserLogged,
  recoveryPassword,
  serverFeaturedOffers,
  serverOffers,
  sidebarAd,
  smallAds,
}) => {
  const router = useRouter();
  const { showDialog } = useDialog();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const { keyword } = router.query;

      showDialog(WishlistDialog, {
        initialValue: keyword,
        onClose: () => {
          router.replace(LINKS.HOME, null, { shallow: true });
        },
      });
    }, TIME_TO_OPEN_WISHLIST_DIALOG_IN_MILLISECONDS);

    return () => {
      clearTimeout(timeout);
    };
  }, [router]);

  return (
    <HomePage
      cardsAds={cardsAds}
      cookieIsUserLogged={cookieIsUserLogged}
      recoveryPassword={recoveryPassword}
      serverFeaturedOffers={serverFeaturedOffers}
      serverOffers={serverOffers}
      sidebarAd={sidebarAd}
      smallAds={smallAds}
    />
  );
};

export const getServerSideProps = getHomeServerSideProps;

export default WishlistPage;
